import { useState, useEffect } from 'react'
import { PropertyApi } from '../apis/PropertyApi'

export const usePropertyCost = (propertyUuid) => {
    const [costData, setCostData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (!propertyUuid) {
            setLoading(false)
            return
        }
        setLoading(true)
        PropertyApi.cost(propertyUuid)
            .then(data => setCostData(data))
            .catch(() => setError('Failed to load cost data'))
            .finally(() => setLoading(false))
    }, [propertyUuid])

    return { costData, loading, error }
}
